import { useIntl } from 'react-intl';
import { SelectButton } from 'primereact/selectbutton';
import { Measure, MEASURES } from './statisticsUtils';

interface MeasureSelectorProps {
    /** Distingue el rótulo cuando hay más de un selector en la pantalla. */
    id: string;
    /** Mensaje del nombre accesible («Medir por», no se ve). La medida es una sola, compartida por la evolución y los horarios. */
    labelId: string;
    value: Measure;
    onChange: (measure: Measure) => void;
}

const MEASURE_LABEL_ID: Record<Measure, string> = {
    attentions: 'ServicesStatisticsMeasureAttentions',
    wait: 'ServicesStatisticsMeasureWait',
    service: 'ServicesStatisticsMeasureService',
};

/**
 * "Medir por": el mismo dato del gráfico en otra medida (atenciones, espera o duración), por eso es un SelectButton. Las
 * opciones se entienden solas: el rótulo es solo el nombre accesible del grupo.
 */
export default function MeasureSelector({ id, labelId, value, onChange }: MeasureSelectorProps) {
    const intl = useIntl();
    const options = MEASURES.map(measure => ({ value: measure, label: intl.formatMessage({ id: MEASURE_LABEL_ID[measure] }) }));
    return (
        <div className="ss-measure">
            <span id={id} className="nv-sr-only">{intl.formatMessage({ id: labelId })}</span>
            <SelectButton
                value={value}
                options={options}
                optionLabel="label"
                optionValue="value"
                onChange={e => { if (e.value) onChange(e.value); }}
                aria-labelledby={id}
            />
        </div>
    );
}
